export default __webpack_public_path__ + "static/media/cancel-rounded-gray.a2398491.svg";